import { render } from "./AddressComment.vue?vue&type=template&id=6897e134"
import script from "./AddressComment.vue?vue&type=script&lang=js"
export * from "./AddressComment.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__